import { Outlet } from 'react-router-dom';
import { RequireFamilyWorkspace } from '../advisor/RequireFamilyWorkspace';
import { firmAssistantEnabled } from '../lib/appEnv';

/**
 * Route guard for `/ask` (steward-app#1541, #1815).
 *
 * With `firmAssistantEnabled()` off this is exactly `RequireFamilyWorkspace to="/"`, #1541's
 * guard: a bookmarked or hand-typed `/ask` in a firm's own workspace lands on `/`, which
 * `HomeRoute` sends on to `/advisor`. With it on, every workspace is admitted, matching
 * `AskControl` in `Layout.tsx`, which reads the same switch.
 *
 * UX gating only. Which assistant answers, and whether a firm question is answered at all, is
 * the façade's decision from the active workspace's packs (`assistant/workspaceKind.ts`).
 */
export function RequireAskWorkspace() {
  if (firmAssistantEnabled()) return <Outlet />;
  return <RequireFamilyWorkspace to="/" />;
}
